import { useGetBaseReport21Mutation } from '@energy-stacks/broker/feature-charging-station-management-data';
import {
  endConfigurationRefetch,
  startConfigurationRefetch,
  useAppDispatch,
} from '@energy-stacks/broker/store';
import { useESSnackbar } from '@energy-stacks/core/ui';
import { useChargingStationIdentityKey } from '@energy-stacks/shared';
import { useCallback } from 'react';

export const useRefreshConfiguration21 = () => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useESSnackbar();
  const identityKey = useChargingStationIdentityKey();
  const [triggerBaseReport21] = useGetBaseReport21Mutation();

  const refreshConfiguration = useCallback(async () => {
    dispatch(startConfigurationRefetch());

    triggerBaseReport21({
      identityKey,
      reportBase: 'FullInventory',
      requestId: 0,
    })
      .unwrap()
      .then(() => {
        setTimeout(() => {
          showSnackbar(
            'success',
            'configurationRetrieveSuccess',
            'chargingStations'
          );
          dispatch(endConfigurationRefetch());
        }, 5000);
      })
      .catch((error) => {
        dispatch(endConfigurationRefetch());
        if (error.data.errorCode === 'RPC_TIMEOUT') {
          showSnackbar('error', 'rpcTimeoutError', 'chargingStations');
          return;
        }
        if (error.data.errorCode === 'RPC_ERROR') {
          showSnackbar('error', 'rpcError', 'chargingStations');
          return;
        }
        showSnackbar('error');
      });
  }, [dispatch, triggerBaseReport21, identityKey, showSnackbar]);

  return refreshConfiguration;
};
